export default __webpack_public_path__ + "static/media/samuel_eich.634c210c.png";